import apiClient from "./client";
import type { CompanyWithRole, CompanyCreate, CompanyUpdate } from "../types";

export async function listCompanies(): Promise<CompanyWithRole[]> {
  const res = await apiClient.get<CompanyWithRole[]>("/api/companies");
  return res.data;
}

export async function createCompany(data: CompanyCreate): Promise<CompanyWithRole> {
  const res = await apiClient.post<CompanyWithRole>("/api/companies", data);
  return res.data;
}

export async function updateCompany(id: string, data: CompanyUpdate): Promise<CompanyWithRole> {
  const res = await apiClient.put<CompanyWithRole>(`/api/companies/${id}`, data);
  return res.data;
}
